import React from 'react';
import './ResearchStudies.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';
import researchData from '../../data/researchData';

const ResearchStudies = () => {
  const { director } = researchData;

  return (
    <div className="research-studies-page" id="research-studies-page-unique">
      <Navbar />
      
      <div className="research-container" id="research-container-unique">
        
        
        {/* Research Director Section */}
        <div className="research-section" id="research-director-section-unique">
          <h2>Director of Research Studies</h2>
          <div className="director-card" id="director-card-unique">
            <div className="director-image" id="director-image-unique">
              <img src={director.image} alt={director.name} />
            </div>
            <div className="director-info" id="director-info-unique">
              <h3>{director.name}</h3>
              <p className="director-qualifications">{director.qualifications}</p>
              <p className="director-position">{director.position}</p>
              <p className="director-department">{director.department}</p>
              <div className="director-contact" id="director-contact-unique">
                <p><i className="fas fa-envelope"></i> {director.email[0]}</p>
                <p><i className="fas fa-envelope"></i> {director.email[1]}</p>
                <p><i className="fas fa-phone"></i> {director.phone}</p>
                <p><i className="fas fa-building"></i> {director.office}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default ResearchStudies;